var rich_content_viewer_default = {
  "fontElementMap": "pcLmu",
  "wrapper": "_8HJdY",
  "pluginContainerMobile": "_5ZuJU",
  "viewer": "WZmlO",
  "android": "UXUYh",
  "rootedTraversedContent": "Qvle0",
  "atomic": "_2OW4P",
  "toolbar": "l4P5g",
  "block": "_6-f0r"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
